/**
 * @author ydoni
 * @description modal 안 toggle
 *              ex) alert Rule show advanced settings
 */

import { Text, ValidateWord } from "components/atoms/text/Text";
import Toggle from "components/atoms/toggle/Toggle";
import styled from "styled-components";
import { COLORS } from "styles/colors";
import { FLEX } from "styles/flex";
import { IoChevronDownOutline, IoChevronUp } from "react-icons/io5";
import {
  Validate,
  ValidateMsg,
} from "api/interfaces/commonInterface.interface";

interface Items {
  title: string;
  value: boolean;
  isShow: boolean;
  children?: React.ReactNode;
  name: any;
}

type ShowToggleProps = {
  items: Array<Items>;
  onToggle: (name: any) => void;
  onChangeAlertRuleInfo?: (type: any, checked: boolean) => void;
  isRecorderPermission?: boolean;
  alertRuleValidate?: Validate;
  alertRuleValidateMsg?: ValidateMsg;
};

function ShowToggle({
  items,
  onToggle,
  onChangeAlertRuleInfo,
  isRecorderPermission,
  alertRuleValidate,
  alertRuleValidateMsg,
}: ShowToggleProps): JSX.Element {
  return (
    <Container>
      {items.map((item, index) => (
        <Item key={index}>
          <Title>
            <Label
              onClick={() => onToggle(item.name)}
              data-testid="blocks-modal-show-label-toggle"
            >
              <Text bold fontSize={18}>
                {item.title}
              </Text>
              {item.isShow ? <IoChevronUp /> : <IoChevronDownOutline />}
            </Label>
            {!isRecorderPermission && onChangeAlertRuleInfo && (
              <Toggle
                isToggled={item.value}
                checked={item.value}
                dataTestId={`blocks-modal-show-toggle-${item.name}`}
                onChange={(
                  checked: boolean,
                  event: React.MouseEvent<HTMLButtonElement>
                ) => {
                  // e.stopPropagation();
                  onChangeAlertRuleInfo(item.name, checked);
                }}
              />
            )}
          </Title>
          {item.isShow && (
            <ShowContainer
              onClick={(e) => e.stopPropagation()}
              data-testid="blocks-modal-show-container-stop-propagation"
            >
              {item.children}
            </ShowContainer>
          )}
        </Item>
      ))}
      {alertRuleValidate?.isRule && alertRuleValidateMsg?.isRule && (
        <ValidateWord data-testid="alert-rule-validate">
          {alertRuleValidateMsg.isRule}
        </ValidateWord>
      )}
    </Container>
  );
}

const Container = styled.ul``;

const Item = styled.li`
  padding: 18px 0;
  border-bottom: 1px solid ${COLORS.BORDER};
`;

const Title = styled.div`
  ${FLEX.FlexBetweenCenter};
`;

const Label = styled.div`
  ${FLEX.FlexStartCenter};
  gap: 7px;
  cursor: pointer;
  > img {
    width: 14px;
    cursor: pointer;
  }
`;

const ShowContainer = styled.div`
  padding: 15px 0 10px;
`;

export default ShowToggle;
